import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "ellipsis" })
export class EllipsisPipe implements PipeTransform {
  // transform(value: string, args: any[]): string {
  //   const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
  //   const trail = args.length > 1 ? args[1] : '...';
  //   return value?.length > limit ? value.substring(0, limit) + trail : value;
  // }

  transform(value: string, args?: [number, string]): string {
    if (!value) return "";

    const limit = args && args[0] ? args[0] : 100;
    const ellipsis = args && args[1] ? args[1] : "...";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = value;

    const textContent = tempDiv.textContent || tempDiv.innerText || "";
    const truncatedText =
      textContent.length > limit
        ? textContent.substring(0, limit) + ellipsis
        : textContent;

    tempDiv.textContent = truncatedText;

    return tempDiv.innerHTML;
  }
}
